/**
 * Copyright 2023-2024 Highway9 Networks Inc.
 */
import { store } from "..";
import evt from "../event";

import { utilityActions } from "../context/utilitySlice";
import { fetchRadioSimulator } from "../context/simulatorSlice";
import { fetchServiceController } from "../context/dashboardSlice";
import { fetchInsights, insightSourceFilter } from "../context/insightSlice";
import type { Insight } from "~/types/Insight";
import { enqueueSnackbar } from "notistack";
import { runSocketRefresh, socketRefreshRegistry, SocketRefreshRegistryKey } from "./socketRefreshRegistry";
import { WebSocketMessage } from "~/types/WebsocketMessage";

// Flag to pause events for monitoring page when historical data is being shown
export let PAUSE_EVENTS = false;
export const pauseEvents = (value: boolean) => {
  PAUSE_EVENTS = value;
};

evt.on("setStartAndEndTime", (startTime, endTime) => {
  store.dispatch(utilityActions.setStartTime(startTime));
  store.dispatch(utilityActions.setEndTime(endTime));
  store.dispatch(utilityActions.setTimeInterval({ interval: "custom" }));
});

// Uniform Entity State websocket refresh — registry-driven
for (const [eventName, entry] of Object.entries(socketRefreshRegistry)) {
  if (!entry) continue;
  // Registry only contains uniform WebSocketMessage[] refresh events.
  evt.on(eventName as SocketRefreshRegistryKey, (data?: WebSocketMessage[]) => {
    runSocketRefresh(entry, data, PAUSE_EVENTS);
  });
}

// --- Bespoke handlers (out of registry scope) ---

evt.on("refreshRadioSimulator", () => {
  store.dispatch(fetchRadioSimulator());
});

evt.on("openSnackbar", (data) => {
  enqueueSnackbar(data.message, {
    variant: data.severity,
  });
});

evt.on("refreshServiceController", () => {
  store.dispatch(fetchServiceController());
});

evt.on("refreshInsights", (status, sourceType, sourceId) => {
  const filter: Partial<Insight> = {
    sourceType: sourceType ?? insightSourceFilter(store.getState()),
    status,
  };
  if (sourceId) filter.source = { id: sourceId } as Insight["source"];
  store.dispatch(fetchInsights(filter));
});
